import { ContentBannerProps } from '@global-components/ContentBanner/ContentBanner';

// In order of priority
export enum ErrorType {
  nonAuUser = 'nonAuUser',
  entityType = 'entityType',
  invalidAddress = 'invalidAddress',
  kyc1 = 'kyc1',
  reverificationReq = 'reverificationReq',
  reverificationLapsed = 'reverificationLapsed',
  kyc2Req = 'kyc2Req',
  kyc2Lapsed = 'kyc2Lapsed',
  userRestricted = 'userRestricted',
}

export type BannerConfig = Pick<
  ContentBannerProps,
  'theme' | 'icon' | 'title' | 'description' | 'actionLabel' | 'onAction' | 'subActionLabel' | 'onSubAction'
>;
